export function isFunction(x) {
  // eslint-disable-next-line eqeqeq
  return Object.prototype.toString.call(x) == "[object Function]";
}
